import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, Output, EventEmitter, AfterContentInit } from '@angular/core';

import { FechasService } from 'src/app/services/fechas/fechas';

import { ImprimiService } from 'src/app/services/imprimir/imprimirService';
import { check, cancel } from 'src/app/config/imagenes';
import { FirmaService } from 'src/app/services/firma/firmaService';
import { estilos_informes } from 'src/app/config/estilos-informes';
import { logo } from 'src/app/config/imagenes';
import { ImageBaseService } from 'src/app/services/imagenes/imagenes.service';


declare var $: any;



@Component({
    selector: 'app-imprimi-control',
    templateUrl: './imprimirControl.component.html',
    styleUrls: ['./imprimirControl.component.css'],
    providers: [ImprimiService, FirmaService]

})
export class ImprimirControlComponent implements OnInit, OnChanges {

    public logo: string = logo;
    public check: string = check;
    public cancel: string = cancel;
    public firma = "";
    public firma_revision = "";
    public baseUrl = "https://traza-brio.com/calidad/ws/upload/firmas/";

    @Input() title: string;
    @Input() id: string;
    @Input() database: string;
    @Output() cerrarVentana = new EventEmitter();


    public anexo = new Date();
    public productos: any = [];
    public oldId = "";
    public oldDatabase = "";
    public productosKey: any[] = [];
    public estructurado: any[] = [];
    public fechaActual = this.fechaService.mostrarFechaActual();
    public closeWindow = true;
    public loading = true;
    public nombre: string = '';
    public procedimiento: string = 'x';
    public numero_anexo: string = 'x';
    public fecha: any = []; 
    
    constructor(
        private fechaService: FechasService,
        private imprimirService: ImprimiService,
        private firmaService: FirmaService,
        private ImageBaseService: ImageBaseService
    ) {
        this.oldId = this.id;
    }
    public myMap = new Map([]);
    ngOnInit(): void {
        this.ImageBaseService.image64(logo).toPromise()
        .then( (resp: string) => {
           
            this.logo = resp;
        }).catch( error => {
            this.logo = logo;
        });
        this.mostrarContenido();


    }
   
    ngOnChanges(changes: SimpleChanges) {
        this.mostrarContenido();
        if (this.id) {
            if (this.oldId != this.id) {
                this.mostrarContenido();
            }

        } else {

        }

    }

    mostrarContenido() {
        this.firma_revision ='';
          
        this.imprimirService.getId(this.id, this.database).subscribe((resp: any) => {

            this.productos = resp;
            //console.log("produc",this.productos);
            this.nombre = this.productos[0].revisado_nombre;
          try {
            this.firmaService.getFirma(this.productos[0].revisado_nombre).toPromise().then((data: any) => {
                //console.log(data);
                try {
                    if (data.productos[0].firma) {
                        this.firma = this.baseUrl + data.productos[0].firma;
    
                    } else {
                        console.log("no hay firma");
    
                        this.firma = null;
                    }
                } catch (error) {
                    this.firma = null;
                }
              

            });
          } catch (error) {
              
          }

          try {
            this.firmaService.getFirma(this.productos[0].revision).toPromise().then((data: any) => {
                //console.log(data);
                try {
                    if (data.productos[0].firma) {
                        this.firma_revision = this.baseUrl + data.productos[0].firma;
    
                    } else {
                        console.log("no hay firma_revision");
    
                        this.firma_revision = null;
                    }
                } catch (error) {
                    this.firma_revision = null;
                }
              

            });
          } catch (error) {
              
          }
           
            let number = 0;
            for (const key in this.productos[0]) {
                this.productosKey.push([key]);

                let recogerPalabra = key;
                let recogercadenas = [];

                let separarFEcha = this.productos[0]['Fecha'].split("/");

                let estructurarFEcha = separarFEcha[2] + "-" + separarFEcha[1] + "-" + separarFEcha[0];
                //console.log("estructurarFEcha",estructurarFEcha);
                this.fecha = estructurarFEcha;
               


                if (key == "id") {

                } else {

                    this.myMap.set(key, this.productos[0][key]);
                    if (recogerPalabra.includes("_")) {

                        recogercadenas = key.split("_");
                        recogerPalabra = this.jsUcfirst(recogercadenas[0]) + " " + recogercadenas[1];
                        recogerPalabra = recogerPalabra.replace("_", " ");
                    }
                    try {
                        if (Number.isInteger(parseInt(recogerPalabra.substring(recogerPalabra.length - 1, recogerPalabra.length)))) {
                            // console.log("true");

                            recogerPalabra = this.jsUcfirst(recogerPalabra.slice(0, recogerPalabra.length - 1)) + " " + recogerPalabra.slice(-1);
                        }
                    } catch (error) {

                    }

                    recogerPalabra = this.jsUcfirst(recogerPalabra);

                    this.estructurado.push(recogerPalabra + " : " + this.productos[0][key]);


                    //this.estructurado.push(recogerPalabra+" : "+this.productos[0][key]);
                }

            }
            this.loading = false;
            //console.log("estructurado", this.estructurado);

        });

    }
    jsUcfirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }


    Export2Doc() {
        // this.convertImagesToBase64();

        var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>"
            + "<style>" + estilos_informes + "</style>"
            + "</head><body > <div style=' font-family: Arial !important;'>";
        var postHtml = "</div></body></html>";
        var html = preHtml + document.getElementById('source-html').innerHTML + postHtml;

        var blob = new Blob(['\ufeff', html], {
            type: 'application/msword'
        });

        // Specify link url
        var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
        let filename = "";
        // Specify file name
        filename = filename ? filename + '.doc' : 'control de calidad.doc';

        // Create download link element
        var downloadLink = document.createElement("a");

        document.body.appendChild(downloadLink);

        if (navigator.msSaveOrOpenBlob) {
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            // Create a link to the file
            downloadLink.href = url;

            // Setting the file name
            downloadLink.download = filename;

            //triggering the function
            downloadLink.click();
        }

        document.body.removeChild(downloadLink);
    }



    convertImagesToBase64() {

        let regularImages = document.querySelectorAll("img");
        console.log("images", regularImages);

        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        [].forEach.call(regularImages, function (imgElement) {
            // preparing canvas for drawing
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = imgElement.width;
            canvas.height = imgElement.height;
            ctx.drawImage(imgElement, 0, 0);
            // by default toDataURL() produces png image, but you can also export to jpeg
            // checkout function's documentation for more details
            var dataURL = canvas.toDataURL();

            debugger;
            imgElement.setAttribute('src', dataURL);
        })
        canvas.remove();
    }

    cerrar() {
        this.cerrarVentana.emit({ closeWindow: false });
    }

}